import { Id, Identifiable, Resource } from "@planzone/dto";
import { Dependencies } from "@planzone/core";

function createProjectHistory(
  getResource: () => Identifiable<Resource>,
): Dependencies["projectHistory"] {
  return {
    getHistory() {
      try {
        const resource = getResource();
        const db = localStorage.getItem(`${resource.uuid}:projectHistory`);

        return Promise.resolve(db ? JSON.parse(db) : []);
      } catch (e) {
        return Promise.reject();
      }
    },
    pushHistory(project) {
      try {
        const resource = getResource();
        const db = localStorage.getItem(`${resource.uuid}:projectHistory`);
        const projects: Id[] = db ? JSON.parse(db) : [];
        const filteredProjects = projects.filter(
          (projectId) => projectId !== project,
        );

        localStorage.setItem(
          `${resource.uuid}:projectHistory`,
          JSON.stringify([project, ...filteredProjects]),
        );

        return Promise.resolve();
      } catch (e) {
        return Promise.reject();
      }
    },
  };
}

export { createProjectHistory };
